import { ChangeEvent } from 'react';
import { format } from 'rut.js';

export function handleRutChange(event: ChangeEvent<HTMLInputElement>) {
  // eslint-disable-next-line no-param-reassign
  event.target.value = format(event.target.value);
}
